import Icon from 'core/components/icons/Icon'
import { useUserProfile } from 'core/hooks/useDataHook'
import { useMemo } from 'react'
import moment from 'moment'

const DeactivatedAccountBanner = () => {
  const { data: { end_date } = {} } = useUserProfile()

  const isDeactivated = useMemo(() => {
    if (!end_date) return false
    return moment().isAfter(moment(end_date, 'M/D/YYYY'))
  }, [end_date])

  const formattedDate = useMemo(() => {
    if (!end_date) return ''
    return moment(end_date, 'M/D/YYYY').format('MMMM D, YYYY')
  }, [end_date])

  return isDeactivated ? (
    <div className="bg-[#28314A] flex items-center gap-5 p-10">
      <div>
        <Icon
          name="deactivated"
          color="text-danger-3"
          className="bg-white p-3 rounded-full"
          width={30}
          height={30}
        />
      </div>
      <div className="flex flex-col gap-2">
        <h2 className="text-white font-medium">
          Your account has been deactivated
        </h2>
        <p className="text-white">
          Your access ended on {formattedDate}. You can still submit reports for
          trips and expenses incurred before {formattedDate}. Contact your
          company manager with any questions.
        </p>
      </div>
    </div>
  ) : null
}

export default DeactivatedAccountBanner
